import { render, staticRenderFns } from "./MultiSelectCategories.vue?vue&type=template&id=4f91ecc9&"
import script from "./MultiSelectCategories.vue?vue&type=script&lang=js&"
export * from "./MultiSelectCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports